export default {"src":"/_next/static/media/icon_blog1.06f8b859.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};